import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Big news: Oscar Reimer joins Controla as CTO & Co‑founder",
  header: "🚀 Big news: Oscar Reimer joins Controla as CTO & Co‑founder",
  date: "2025-09-24",
  description:
    "Why Oscar is joining Controla, his journey from Debricked, and what this means for the future of our product.",
  category: "company",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
